import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class PanelHeaderSummaryInfo extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    customValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    className: "",
    customValue: null,
    label: "",
    tooltipContent: "",
    value: ""
  };

  state = {
    displayTooltip: false
  };

  get tooltipContent() {
    if (typeof this.props.tooltipContent === "function") {
      return this.props.tooltipContent();
    }

    return this.props.tooltipContent;
  }

  handleMouseEnter = () => this.setState({ displayTooltip: true });

  handleMouseLeave = () => this.setState({ displayTooltip: false });

  render() {
    const { className, customValue, label, value } = this.props;

    return (
      <div className={classNames("panel-summary__info", className)}>
        <p onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} className="panel-summary__label">
          {label}
        </p>
        {this.props.tooltipContent && this.state.displayTooltip && <span className="header-tooltip -summary">{this.tooltipContent}</span>}
        {customValue && customValue}
        {!customValue && <p className="panel-summary__value">{value}</p>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelHeaderSummaryInfo.js